import { useAtomValue } from "jotai";
import React, { createContext, PropsWithChildren, useContext } from "react";
import { ActiveIdAtom } from "utilities/hooks/scroll-spy/use-section-scroll-spy";

interface MobileTableOfContentsContextProps {
    isBookview: boolean;
    onClick: () => void;
}

const MobileTableOfContentsContext = createContext<
    MobileTableOfContentsContextProps | undefined
>(undefined);

interface MobileTableOfContentsProviderProps {
    onClick: () => void;
}

const MobileTableOfContentsProvider: React.FC<
    PropsWithChildren<MobileTableOfContentsProviderProps>
> = ({ children, onClick }) => {
    return (
        <MobileTableOfContentsContext.Provider
            value={{ isBookview: true, onClick }}>
            {children}
        </MobileTableOfContentsContext.Provider>
    );
};

export default MobileTableOfContentsProvider;

interface UseMobileTableOfContentsContextResult
    extends MobileTableOfContentsContextProps {
    activeSectionId: number | null;
}
export const useMobileTableOfContentsContext =
    (): UseMobileTableOfContentsContextResult => {
        const context = useContext(MobileTableOfContentsContext);
        const activeSectionId = useAtomValue(ActiveIdAtom);

        if (context === undefined) {
            return {
                isBookview: false,
                activeSectionId: null,
                onClick: () => {},
            };
        }

        return { ...context, activeSectionId };
    };
